// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordMatch, passwordPattern, showFormErrors } from 'src/app/utils/form-utils';

@Component({
    selector: 'password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    @Input() onPasswordValid: (password) => void;
    @Input() onPasswordInvalid: () => void;
    @Input() showTitle = true;
    @Input() title = 'Create a new password';
    @Input() subTitle = '';
    @Input() showRequirements = true;
    @Input() requirementsAboveFields = true;
    @Input() hideConfirmPassword = false;
    isComponentAlive = true;
    newPasswordForm: FormGroup;
    error: string = null;
    viewPassword: [boolean, boolean] = [false, false];
    passwordRequirements = {
        hasLower: false,
        hasUpper: false,
        hasNumber: false,
        hasSpecialChar: false,
        hasMinLength: false,
        bothMatch: false,
    };

    constructor() {}

    ngOnInit(): void {
        this.newPasswordForm = new FormGroup(
            {
                password: new FormControl('', [Validators.required, Validators.pattern(passwordPattern)]),
                password2: new FormControl('', [Validators.required]),
            },
            { validators: passwordMatch }
        );
    }

    validityCheck(): void {
        const { password, password2 } = this.newPasswordForm.value;

        if (this.hideConfirmPassword) {
            this.newPasswordForm.patchValue({ password2: password });
        }

        if (this.newPasswordForm.status === 'INVALID') {
            showFormErrors(this.newPasswordForm.controls);
            this.onPasswordInvalid();
            return;
        }

        if (password !== password2 && !this.hideConfirmPassword) {
            this.newPasswordForm.get('password2').setErrors({ password: 'not equal' });
            this.onPasswordInvalid();
            return;
        }

        this.onPasswordValid(password);
    }

    public togglePasswordVisible(passwordField: 1 | 2): void {
        this.viewPassword[passwordField - 1] = !this.viewPassword[passwordField - 1];
    }
}
